import { CargoTankTemperatureBM } from '../types/BusinessModel/CargoTankTemperatureBM';
import { CargoTankTemperature } from '../types/ViewModel/CargoTankTemperature';

export class CargoTankTemperatureFactory {
    public create(data: CargoTankTemperatureBM): CargoTankTemperature {
        return new CargoTankTemperature(
            data.cargoNumber,
            data.commodityId,
            data.tankId,
            data.isOnBoard,
            data.isInhibitedCargo,
            data.isCooledCargo,
            data.isHeatedCargo,
            data.tradeName,
            data.temperature,
            data.cargoLoadingTemperature
        );
    }
    public createBM(data: any): CargoTankTemperatureBM {
        return {
            cargoNumber: data.cargoNumber,
            commodityId: data.commodityId,
            tankId: data.tankId,
            isOnBoard: data.isOnBoard,
            isInhibitedCargo: data.isInhibitedCargo,
            isCooledCargo: data.isCooledCargo,
            isHeatedCargo: data.isHeatedCargo,
            tradeName: data.tradeName,
            temperature: data.temperature,
            cargoLoadingTemperature: data.cargoLoadingTemperature,
        };
    }

    public createList(data: CargoTankTemperatureBM[]): CargoTankTemperature[] {
        return data.map((h) => this.create(h));
    }
}
